import './TakeAction.scss';

import {Button} from "./Reusable"
import speaches from "../resources/images/speach.webp";

// This used to assert urgency without supplying any ("there's no better time
// than now"). The real argument is the calendar: the film has to exist before
// the campaign it serves, and the work that makes it runs backward from a date
// the client already has. The benefit claims that used to live here moved to
// Outcomes — this section is urgency only now.
function TakeAction() {
    return (
        <>
            <div className="TakeAction">
                <img src={speaches} className="TakeAction-image reveal" alt=""
                    loading="lazy" decoding="async" />
                <div className="TakeAction-container reveal delay-1">
                    <h2>Why Now?</h2>
                    <p>Campaign video runs backward from <b>a date you've already set.</b> If
                    the appeal launches in Advent, the film has to be finished before it.</p>
                    <p>Finishing means a script everyone signs off on, a shoot day your people
                    can actually all make, and weeks in the edit after that. The calendar only
                    moves one direction — starting early is the difference between comfortable
                    and tight.</p>
                    {/* Once you've settled on a turnaround you're willing to commit to,
                        the concrete version of the line above is stronger: "Most projects
                        want N weeks of runway." Left out rather than guessed at. */}
                    <br />
                    <Button title="Start the conversation" flameon={true} source="Why Now section" />
                </div>
            </div>
        </>
    );
}

export default TakeAction;
